import React, { useState, useEffect } from 'react'

import Button from '../button'

export default ({ loadingText, loading: pLoading, onClick, children, ...otherProps }) => {
  const [loading, setLoading] = useState(pLoading)
  const doClick = (evt) => {
    if (!loading) {
      setLoading(true)
      const returnVal = onClick && onClick(evt, () => setLoading(false))

      if (returnVal instanceof Promise) {
        returnVal.then(() => setLoading(false)).catch(() => setLoading(false))
      }
    }
  }

  useEffect(() => {
    setLoading(pLoading)
  }, [pLoading])

  return (
    <Button {...otherProps} loading={loading} onClick={doClick}>
      {loading ? loadingText || children : children}
    </Button>
  )
}
